import LoginForm from "../../components/login";

const LoginPage = () => {
    return (
        <LoginForm />
    )
}

export default LoginPage;